import Reports from '@/components/modules/reports/index';
import Reportsv2 from '@/components/modules/reports/reportV2';

const routes = [
  {
    path: '/reports/',
    name: 'Reports',
    component: Reports,
    meta: {
      title: 'Reports',
    },
  },
  {
    path: '/reportsv2',
    name: 'ReportsV2',
    component: Reportsv2,
    meta: {
      title: 'Reports v2',
      requiresAuth: true,
    },
  },
];
export default routes;
